import React, { useEffect, useState } from 'react'
import { Typography, Box } from '@material-ui/core'

import { InfoOutlined } from '@material-ui/icons'
import { useGlobalContext } from '../../../state'

import { useMapEngine } from '../../shared'
import { MAP_ID } from '../../../utils/apiHelper'
import { t } from '../../../utils/languages'

export const IndicatorDefinition = () => {
  const [engine] = useMapEngine(MAP_ID)
  const [indicatorId, setIndicatorId] = useState('')
  const [name, setName] = useState('')
  const [definition, setDefinition] = useState('')

  const {
    state: { layers }
  } = useGlobalContext()

  useEffect(() => {
    const selectedLayer = layers.filter(
      ({ kind, isVisible }) => isVisible && kind === 'INDICATOR'
    )[0]
    if (engine && selectedLayer) {
      const {
        metadata: { indicator_id, indicator_name, definition }
      } = selectedLayer

      setDefinition(definition)
      setName(indicator_name)
      setIndicatorId(indicator_id)
    } else {
      setName('')
      setDefinition('')
      setIndicatorId('')
    }
  }, [engine, layers])

  return (
    <Box style={{ padding: '0px 16px' }}>
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid black',
          padding: '16px'
        }}
      >
        <InfoOutlined fontSize="large" style={{ marginRight: 8 }} />
        <Typography variant="h5">{t('Descripción / Ficha técnica')}</Typography>
      </Box>
      {name && (
        <>
          <Box
            style={{
              borderBottom: '1px solid black',
              padding: '16px'
            }}
          >
            <Typography variant="h5">{t(name)}</Typography>
          </Box>
          <Box
            style={{
              padding: '0px 16px'
            }}
            dangerouslySetInnerHTML={{ __html: definition }}
          />
          <Box>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
              target="_blank"
              // eslint-disable-next-line max-len
              href={`https://statistics.cepal.org/portal/cepalstat/technical-sheet.html?lang=es&indicator_id=${indicatorId}`}
              rel="noreferrer"
            >
              <Typography variant="h6">
                {t('Acceda a la ficha metodológica')}
              </Typography>
            </a>
            <InfoOutlined fontSize="large" style={{ marginRight: 8 }} />
          </Box>
        </>
      )}
    </Box>
  )
}
